<div class="catalog-filters">
  <!-- Clear All Filters Button -->
  <button class="catalog-filters__clear-button" (click)="clearAllFilters()">
    <p>{{ 'charity_catalog.filter.clear_all' | translateLang }}</p>
  </button>

  <!-- Sort By Section -->
  <div class="catalog-filters__section" *ngIf="hasSortItems()">
    <app-criteria-selector
      [icon]="'/assets/images/icons/sort-by-icon.svg'"
      [title]="'charity_catalog.sort.title'"
      [items]="sortItems()"
      [multiSelect]="false"
      [variant]="'default'"
      (selectionChanged)="onSortChanged($event)">
    </app-criteria-selector>
  </div>

  <!-- Filters Section -->
  <div class="catalog-filters__section">
    <div class="catalog-filters__header">
      <img
        src="/assets/images/icons/filter-icon.svg"
        alt=""
        class="catalog-filters__icon"
      />
      <p class="catalog-filters__title">{{ 'charity_catalog.filter.title' | translateLang }}</p>
    </div>

    <div class="catalog-filters__dropdown-list">
      <!-- Address Filter (ORGANISATION only) -->
      <ng-container *ngIf="hasAddressItems()">
        <app-criteria-selector
          [dropdownTitle]="'charity_catalog.filter.address'"
          [showMainTitle]="false"
          [items]="addressItems()"
          [multiSelect]="true"
          [variant]="'dropdown'"
          [initialExpanded]="false"
          (selectionChanged)="onAddressChanged($event)">
        </app-criteria-selector>

        <div class="catalog-filters__divider"></div>
      </ng-container>

      <!-- Country Filter -->
      <ng-container *ngIf="hasCountryItems()">
        <app-criteria-selector
          [dropdownTitle]="'charity_catalog.filter.country'"
          [showMainTitle]="false"
          [items]="countryItems()"
          [multiSelect]="true"
          [variant]="'dropdown'"
          [initialExpanded]="false"
          (selectionChanged)="onCountryChanged($event)">
        </app-criteria-selector>

        <div class="catalog-filters__divider"></div>
      </ng-container>

      <!-- Region Filter -->
      <ng-container *ngIf="hasRegionItems()">
        <app-criteria-selector
          [dropdownTitle]="'charity_catalog.filter.region'"
          [showMainTitle]="false"
          [items]="regionItems()"
          [multiSelect]="true"
          [variant]="'dropdown'"
          [initialExpanded]="false"
          (selectionChanged)="onRegionChanged($event)">
        </app-criteria-selector>

        <div class="catalog-filters__divider"></div>
      </ng-container>

      <!-- Cause Filter -->
      <ng-container *ngIf="hasCauseItems()">
        <app-criteria-selector
          [dropdownTitle]="'charity_catalog.filter.cause'"
          [showMainTitle]="false"
          [items]="causeItems()"
          [multiSelect]="true"
          [variant]="'dropdown'"
          [initialExpanded]="false"
          (selectionChanged)="onCauseChanged($event)">
        </app-criteria-selector>

        <div class="catalog-filters__divider"></div>
      </ng-container>

      <!-- Category Filter -->
      <ng-container *ngIf="hasCategoryItems()">
        <app-criteria-selector
          [dropdownTitle]="'charity_catalog.filter.category'"
          [showMainTitle]="false"
          [items]="categoryItems()"
          [multiSelect]="true"
          [variant]="'dropdown'"
          [initialExpanded]="false"
          (selectionChanged)="onCategoryChanged($event)">
        </app-criteria-selector>

        <div class="catalog-filters__divider"></div>
      </ng-container>

      <!-- Champions Filter -->
      <ng-container *ngIf="hasChampionsItems()">
        <app-criteria-selector
          [dropdownTitle]="'charity_catalog.filter.champions'"
          [showMainTitle]="false"
          [items]="championsItems()"
          [multiSelect]="true"
          [variant]="'dropdown'"
          [initialExpanded]="false"
          (selectionChanged)="onChampionsChanged($event)">
        </app-criteria-selector>

        <div class="catalog-filters__divider"></div>
      </ng-container>
    </div>
  </div>
</div>
